export default __webpack_public_path__ + "static/media/f51.3a0751ab.png";